import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Modal, Row, Select, Switch } from "antd";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { rawMaterialsCredentialsSchema } from "../../../../../validattion";
import { yupResolver } from "@hookform/resolvers/yup";
import numeral from "numeral";

const { Option } = Select;

const CreateRawMaterialModal = (props) => {
  const {
    visible,
    formMode,
    closeModal,
    one_raw_material_inventory,
    UpdateRawMaterialInventory,
    CreateRawMaterialInventory,
    GetAllRawMaterials,
    allRawMaterials,
  } = props;
  const [loading, setLoading] = useState(false);

  const checkMode = formMode === "CREATE_MODE";
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(rawMaterialsCredentialsSchema),
  });

  useEffect(() => {
    const getRawMaterialsRecords = async () => {
      const res = await GetAllRawMaterials();
      if (!res.success) {
        setLoading(false);
        toast.error(`Error`);
      }
    };
    getRawMaterialsRecords();
  }, [GetAllRawMaterials]);

  const closeRawMaterial = () => {
    reset({
      raw_material: null,
      cost: "",
      quantity: "",
    });
    closeModal();
  };
  const createRawMaterialInventory = async (data) => {
    setLoading(true);
    if (formMode === "CREATE_MODE") {
      const createObj = {
        ...data,
      };
      const res = await CreateRawMaterialInventory(createObj);
      if (res.success) {
        setLoading(false);
        toast.success("Raw Materials Inventory Created Successfully", {
          pauseOnHover: false,
        });
        closeRawMaterial();
        requestAnimationFrame(() => {
          closeRawMaterial();
          setLoading(false);
        });
      } else if (!res.success && res.message === undefined) {
        setLoading(false);
        toast.error("Network Error", {
          pauseOnHover: true,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          pauseOnHover: true,
        });
      }
      setLoading(false);
    } else if (formMode === "UPDATE_MODE") {
      const updateObj = {
        id: one_raw_material_inventory?.id,
        ...data,
      };
      const res = await UpdateRawMaterialInventory(updateObj);
      if (res.success) {
        setLoading(false);
        toast.success("Raw Materials Inventory Updated Successfully", {
          pauseOnHover: false,
        });
        closeRawMaterial();
        requestAnimationFrame(() => {
          closeRawMaterial();
          setLoading(false);
        });
      } else if (!res.success && res.message === undefined) {
        setLoading(false);
        toast.error("Network Error", {
          pauseOnHover: true,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          pauseOnHover: true,
        });
      }
    }
  };

  const children = allRawMaterials?.map((obj) => {
    return (
      <Option key={obj.id} value={obj.id}>
        {obj.name}
      </Option>
    );
  });
  useEffect(() => {
    if (one_raw_material_inventory) {
      setValue("raw_material", one_raw_material_inventory?.raw_material);
    }
  }, [one_raw_material_inventory]);

  const parsePrice = (formatted) => {
    const unformatted = formatted.replace(/,/g, "");
    const parsed = parseFloat(unformatted);
    return isNaN(parsed) ? 0 : parsed;
  };

  return (
    <>
      <Modal
        visible={visible}
        title={
          <p style={{ fontWeight: "bold" }}>
            {checkMode
              ? "Create Raw Material Inventory"
              : `Update Raw Material Inventory`}
          </p>
        }
        footer={null}
        onCancel={closeRawMaterial}
        maskClosable={false}
        width={"400px"}
      >
        <form
          onSubmit={handleSubmit(createRawMaterialInventory)}
          autoComplete="off"
        >
          <div className="content">
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Raw Material</label>
                  <Controller
                    name="raw_material"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Select
                        // allowClear
                        {...register("raw_material")}
                        name="raw_material"
                        placeholder="Select a raw material"
                        style={{ width: "100%" }}
                        size="large"
                        value={value}
                        onChange={onChange}
                      >
                        {children}
                      </Select>
                    )}
                  />
                  {errors.raw_material && (
                    <span className="error">Raw material is a required</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Cost</label>
                  <Controller
                    name="cost"
                    control={control}
                    render={({ field }) => {
                      const formatted = field.value
                        ? numeral(field.value).format("0,")
                        : "";
                      return (
                        <input
                          value={formatted}
                          onChange={(e) =>
                            field.onChange(parsePrice(e.target.value))
                          }
                          onBlur={(e) =>
                            field.onChange(parsePrice(e.target.value))
                          }
                          className="ant-input ant-input-lg"
                          placeholder="Type in Cost"
                        />
                      );
                    }}
                  />
                  {errors.cost && (
                    <span className="error">{errors.cost?.message}</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Quantity</label>
                  <input
                    name="quantity"
                    className="ant-input ant-input-lg"
                    placeholder="Type in Quantity"
                    type="number"
                    {...register("quantity", { required: true })}
                  />
                  {errors.quantity && (
                    <span className="error">{errors.quantity?.message}</span>
                  )}
                </Col>
              </Row>
            </div>
          </div>
          <Divider />
          <Row style={{ margin: "2rem 0" }}>
            <Col xs={24} style={{ textAlign: "right" }}>
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                style={{ marginRight: "10px" }}
              >
                {formMode === "CREATE_MODE" ? "Save" : "Update"} Inventory
              </Button>
            </Col>
          </Row>
        </form>
      </Modal>
    </>
  );
};

export default CreateRawMaterialModal;
